<template>
  <v-content class="artist-container">
    <v-container grid-list-xl style="padding-block: 10px; margin-top: 10px">
    <!-- <div class="dashboard-header">
  <h3> <img src="@/assets/AIANALYST450px.png" alt="AI Avatar" class="ai-avatar2"> AI Tour Analyst</h3>
</div> -->
      <v-card dark class="card-animate-2 mb-5">
                  <v-app-bar
            color="rgba(12, 22, 27, 0.9)"
            max-height="150"
            height="125"
            elevation="3"
            dense
            dar12
          >
          <v-toolbar-title>
            <v-avatar size="40">
              <img src="@/assets/CodexData.png" />
            </v-avatar>
            <span class="ml-2">Tour Analyst</span>
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-chip class="ml-2" color="#00ffe5" text-color="black">Google</v-chip>
          <v-chip class="ml-2" color="#00ffe5" text-color="black">Ticketmaster</v-chip>
          <v-chip class="ml-2" color="#00ffe5" text-color="black">Spotify</v-chip>
          <v-chip class="ml-2" color="#00ffe5" text-color="black">OpenAI</v-chip>
        </v-app-bar>
      </v-card>
  <!-- <v-card dark class="card-animate-2">
          <v-app-bar
            color="rgba(12, 22, 27, 0.9)"
            max-height="150"
            height="125"
            elevation="3"
            dense
            dar12
          >
            <v-toolbar-title>
              <v-avatar size="40">
                                <img src="@/assets/CodexData.png">
                        </v-avatar>
              Tour Analyst
            </v-toolbar-title>
         <br />
          <v-chip
            class="ml-2"
            color="#00ffe5"
            text-color="black"
            style="font-size: 15px; font-weight: bold; padding: 10px 20px;"
            >Google</v-chip>
          <v-chip
            class="ml-2"
            color="#00ffe5"
            text-color="black"
            style="font-size: 15px; font-weight: bold; padding: 10px 20px;"
            >Ticketmaster</v-chip>
          <v-chip
            class="ml-2"
            color="#00ffe5"
            text-color="black"
            style="font-size: 15px; font-weight: bold; padding: 10px 20px;"
            >Spotify</v-chip>
          <v-chip
            class="ml-2"
            color="#00ffe5"
            text-color="black"
            style="font-size: 15px; font-weight: bold; padding: 10px 20px;"
            >Open AI</v-chip>
          
            <v-spacer></v-spacer>
          </v-app-bar>
        </v-card>   -->
        <br />
                <br />
<TourAIAssistant ref="tourAssistant" @artist-submitted="handleAssistantArtist" @start-steps="handleStepTrigger" class="card-animate-2 mb-5" />
<p v-if="loading" class="loading-text">Loading artist data...</p>
    <!-- Search Input -->



    <!-- Artist Profile -->
    <section v-if="artistData" class="artist-profile">
      <h3>{{ artistData.name }}</h3>
      <img :src="artistData.images.length ? artistData.images[0].url : ''" alt="Artist Image" class="artist-image" />
      <br />
      <h4><strong>Listeners:</strong> {{ artistData.followers.total }}</h4>
      <h4><strong>Popularity:</strong> {{ artistData.popularity }}</h4>
      <h4><strong>Genres:</strong> {{ artistData.genres.join(', ') }}</h4>
<br />
<br />
      <v-divider dark></v-divider>

      <h3>Past Tours ({{ pastConcerts.length }})</h3>
      <div class="ticket-grid">
  <div
    v-for="concert in paginatedPastConcerts"
    :key="concert.id"
    class="ticket-card past-ticket"
  >
  <p class="ticket-date">{{ concert.date }}</p>
<p class="ticket-venue">{{ concert.venue }}</p>
<p class="ticket-location">{{ concert.location }}</p>
<p v-if="concert.lat && concert.lng" class="ticket-coords">
  <small>📍 Lat: {{ concert.lat }}, Lng: {{ concert.lng }}</small>
</p>
<p v-if="concert.source" class="ticket-source">
  <em>Source: {{ concert.source }}</em>
</p>

    <p v-if="concert.source === 'AI-Enhanced'" class="ticket-source"><em>AI-Enhanced</em></p>
    <p v-if="concert.source === 'Prediction'" class="ticket-source"><em>AI-Predicted</em></p>

  </div>
</div>

      <v-btn @click="paginationLimit += 10">Load More</v-btn>




<h3>Upcoming Events ({{ futureConcerts.length }})</h3>
<div class="ticket-grid">
  <div
    v-for="event in futureConcerts"
    :key="event.id"
    class="ticket-card"
  >
    <p class="ticket-date">{{ event.date }}</p>
    <p class="ticket-venue">{{ event.venue }}</p>
    <p class="ticket-location">{{ event.location }}</p>
    <p v-if="event.lat && event.lng" class="ticket-coords">
      <small>📍 Lat: {{ event.lat }}, Lng: {{ event.lng }}</small>
    </p>
    <p v-if="event.source" class="ticket-source">
      <em>Source: {{ event.source }}</em>
    </p>
  </div>
</div>

<v-divider dark></v-divider>

<h3>Interactive Tour Map</h3>
<div id="tour-map"></div>
      <v-divider dark></v-divider>

      <h3>Predicted Tours ({{ futureTours.length }})</h3>
<div class="ticket-grid">
  <div
    v-for="tour in futureTours"
    :key="tour.id"
    class="ticket-card predicted-ticket"
  >
    <p class="ticket-date">{{ tour.date }}</p>
    <p class="ticket-venue">{{ tour.venue }}</p>
    <p class="ticket-location">{{ tour.city }}, {{ tour.country }}</p>
    <p v-if="tour.source" class="ticket-source">Source: {{ tour.source }}</p>
  </div>
</div>

<v-divider dark class="my-5"></v-divider>

<v-divider class="my-5"></v-divider>

<h3 class="ai-report-title">📘 AI Tour Report Summary</h3>
<div class="ai-report styled-report">
  <div v-if="aiTourSummary" class="report-text" v-html="aiTourSummary.replace(/\n/g, '<br>')"></div>
  <div v-else>Report not available.</div>
</div>



      <div v-if="showHeatmap" style="margin-top: 30px;">
       
        <BarChart :data="regionChartData" :options="chartOptions" />

      </div>

      <v-divider dark></v-divider>
<br key="v-divider" />
      <br key="v-divider" />
      <v-btn @click="analyzeTourData" :disabled="loadingAI" class="analyze-button">
        {{ loadingAI ? "Analyzing..." : "AI Tour Analysis" }}
      </v-btn>

      <v-btn @click="openGoogleSearch" class="analyze-button">Google Artist Tour Search</v-btn>
      <v-btn @click="saveArtist" class="save-button">Save Artist</v-btn>
      <v-btn
  v-if="isEditing"
  @click="saveArtist"
  class="save-button"
>
  Save Changes
</v-btn>

    </section>
    <div v-if="isEditing">
  <h3>Edit Future Concerts</h3>
  <table>
    <thead>
      <tr>
        <th>Date</th>
        <th>Venue</th>
        <th>Location</th>
        <th>Source</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(event, index) in futureConcerts" :key="index">
        <td><input v-model="event.date" /></td>
        <td><input v-model="event.venue" /></td>
        <td><input v-model="event.location" /></td>
        <td>{{ event.source }}</td>
        <td>
          <v-btn small color="red" @click="futureConcerts.splice(index, 1)">🗑</v-btn>
        </td>
      </tr>
    </tbody>
  </table>
</div>

    <!-- Saved Artists Gallery -->

    <section v-if="artistGallery.length" class="gallery">

  <div class="artist-cards">
    <div
      v-for="artist in artistGallery"
      :key="artist.id"
      class="artist-card"
    >
      <div class="card-header">
        <img :src="artist.image" alt="Artist" class="gallery-image" />
        <div class="artist-meta">
          <h3 class="artist-name">{{ artist.name }}</h3>
          <p class="summary-text" v-if="artist.aiTourSummary">
            {{ artist.aiTourSummary.slice(0, 180) }}...
          </p>
        </div>
      </div>

      <div class="stats">
        <div class="stat-item">
          <span class="stat-label">Past Tours</span>
          <span class="stat-value">{{ artist.pastCount || 0 }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Upcoming</span>
          <span class="stat-value">{{ artist.futureCount || 0 }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Predicted</span>
          <span class="stat-value">{{ artist.predictedCount || 0 }}</span>
        </div>
      </div>

      <div class="location-info">
        <p><strong>📍 Map:</strong> Zoom {{ artist.mapZoom || 'n/a' }} — Lat {{ artist.mapCenter?.lat?.toFixed(2) || '—' }}, Lng {{ artist.mapCenter?.lng?.toFixed(2) || '—' }}</p>
      </div>

      <div class="mini-lists">
        <div class="mini-block">
          <h4>Past</h4>
          <ul>
            <li v-for="(c, i) in artist.pastConcerts.slice(0, 2)" :key="i">{{ c.date }} — {{ c.venue }} ({{ c.location }})</li>
          </ul>
        </div>
        <div class="mini-block">
          <h4>Upcoming</h4>
          <ul>
            <li v-for="(e, i) in artist.futureConcerts.slice(0, 2)" :key="i">{{ e.date }} — {{ e.venue }} ({{ e.location }})</li>
          </ul>
        </div>
        <div class="mini-block">
          <h4>Predicted</h4>
          <ul>
            <li v-for="(t, i) in artist.predictions.slice(0, 2)" :key="i">{{ t.date }} — {{ t.venue || t.city }} ({{ t.location || t.city + ', ' + t.country }})</li>
          </ul>
        </div>
      </div>

      <div class="artist-card-buttons">
        <v-btn class="edit-button" @click="editArtist(artist)">✏️ Edit</v-btn>
        <v-btn class="delete-button" @click="deleteArtist">🗑 Delete</v-btn>
      </div>
    </div>
  </div>
</section>
<br />
    <section v-if="artistSuggestions.length" class="suggestions">
      <h3>Artist Suggestions</h3>
      <ul>
        <li v-for="artist in artistSuggestions" :key="artist.id" @click="selectArtist(artist)">
          <img :src="artist.images[0]?.url" alt="Artist Image" class="suggestion-image" />
          <span>{{ artist.name }}</span>
        </li>
      </ul>
    </section>

    </v-container>
  </v-content>
</template>

<script>
/* global google */
import axios from "axios";
import BarChart from '../components/BarChart.vue'
import TourAIAssistant from '../components/TourAIAssistant.vue'

export default {
  components: {
    BarChart,
    TourAIAssistant
  },
  data() {
    return {
      artistQuery: "",
      artistData: null,
      pastConcerts: [],
      paginationLimit: 10,
      isEditing: false,
      mapCenter: { lat: 37.7749, lng: -122.4194 },
      mapZoom: 2,
      futureConcerts: [],
      futureTours: [],
      groupedTours: {},
      artistGallery: [],
      aiTourReport: "",
      loading: false,
      loadingAI: false,
      aiTourSummary: '',
      aiTourPattern: '',
      aiTourAnalysis: '',
      aiClientReport: '',
      spotifyToken: "",
      editingArtistId: null,
      artistSuggestions: [],
      ticketmasterEvents: [],
      bandsintownEvents: [],
      predictedChartData: {
      labels: [],
      datasets: [
        {
          label: "Predicted Tours per Month",
          data: [],
          backgroundColor: "#9C27B0"
        }
      ]
    },
      map: null,
      venueCapacityFilter: 5000,
showHeatmap: false,
regionChart: null,
regionChartData: {
  labels: [],
  datasets: [
    {
      label: "Past Tours by Country",
      data: [],
      backgroundColor: "#1db954"
    }
  ]
},

directionsService: null,
directionsRenderer: null,
pastTourData: [],
      tourPredictions: [],
      tourChartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        plugins: {
          title: {
            display: true,
            text: 'Past Tours by Country'
          },
          legend: { display: false }
        }
      },
    };
  },
  methods: {
    async handleAssistantArtist(artistName) {
    this.artistQuery = artistName;
    await this.searchArtist();
  },
  handleStepTrigger(artistName) {
  this.artistQuery = artistName;
  this.searchArtist();

  // Optional: Delay before analyzing
  setTimeout(() => {
    this.analyzeTourData();
  }, 2000);
},
    async fetchArtistSuggestions() {
      const token = await this.getSpotifyToken();
      try {
        const response = await axios.get(`https://api.spotify.com/v1/search?q=${this.artistQuery}&type=artist&limit=5`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.artistSuggestions = response.data.artists.items;
      } catch (error) {
        console.error('Error fetching artist suggestions:', error);
      }
    },
    updatePredictedChartData() {
    const monthlyCount = {};
    this.futureTours.forEach(tour => {
      const [year, month] = tour.date.split("-");
      const key = `${year}-${month}`;
      monthlyCount[key] = (monthlyCount[key] || 0) + 1;
    });

    this.predictedChartData.labels = Object.keys(monthlyCount);
    this.predictedChartData.datasets[0].data = Object.values(monthlyCount);
  },
saveArtist() {
  const artist = {
    id: this.artistData.id,
    name: this.artistData.name,
    image: this.artistData.images.length ? this.artistData.images[0].url : '',
    isFavorite: false,

    // Save all relevant data
    pastConcerts: this.pastConcerts,
    futureConcerts: this.futureConcerts,
    predictions: this.futureTours,

    aiTourSummary: this.aiTourSummary,
    aiTourPattern: this.aiTourPattern,
    aiTourAnalysis: this.aiTourAnalysis,
    aiClientReport: this.aiClientReport,

    pastCount: this.pastConcerts.length,
    futureCount: this.futureConcerts.length,
    predictedCount: this.futureTours.length,

    // Save map state
    mapCenter: this.map?.getCenter()?.toJSON() || { lat: 37.7749, lng: -122.4194 },
    mapZoom: this.map?.getZoom() || 2
  };

  const index = this.artistGallery.findIndex(a => a.id === artist.id);
  if (index !== -1) {
    this.artistGallery[index] = artist;
  } else {
    this.artistGallery.push(artist);
  }

  localStorage.setItem("artistGallery", JSON.stringify(this.artistGallery));
  this.isEditing = false;
},
    toggleFavorite(artist) {
    artist.isFavorite = !artist.isFavorite;
    localStorage.setItem("artistGallery", JSON.stringify(this.artistGallery));
  },
    selectArtist(artist) {
      this.artistData = artist;
      this.artistSuggestions = [];
      this.fetchArtistDetails();
    },


    async searchArtist() {
      this.loading = true;
      this.pastConcerts = [];
      this.futureConcerts = [];
      this.futureTours = [];
      this.aiTourReport = '';

      try {
        this.spotifyToken = await this.getSpotifyToken();
        const response = await axios.get(`https://api.spotify.com/v1/search?q=${this.artistQuery}&type=artist`, {
          headers: { Authorization: `Bearer ${this.spotifyToken}` }
        });

        if (response.data.artists.items.length === 0) {
          alert('Artist not found on Spotify!');
          return;
        }

        this.artistData = response.data.artists.items[0];

        await Promise.all([
          this.getTicketmasterEvents(),
          this.getBandsintownEvents(),
          this.getSetlistFmData()
        ]);

        this.displayGoogleMap();
        this.generateRegionHeatmap();
      } catch (error) {
        console.error('Error searching artist:', error);
      } finally {
        this.loading = false;
      }
    },

    async fetchArtistDetails() {
      await Promise.all([this.getTicketmasterEvents(), this.getBandsintownEvents(), this.getSetlistFmData()]);  
      this.updateChartData();
    },
    loadGoogleMapsAPI() {
  if (typeof window.google === "undefined" || !window.google.maps) {
    // Load Google Maps Script
    const script = document.createElement("script");
    script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBboVjZMYbpCulM_NhAuW5I_e6ZwD5f8qA&callback=initMap";
    script.defer = true;
    script.async = true;

    // Create global initMap function so Google Maps can call it
    window.initMap = () => {
      this.loadMarkerClusterer(() => {
        this.displayGoogleMap();
      });
    };

    document.head.appendChild(script);
  } else {
    // Already loaded
    this.displayGoogleMap();
  }
},

loadMarkerClusterer(callback) {
  // Check if already loaded
  if (window.MarkerClusterer) {
    callback();
    return;
  }

  const clusterScript = document.createElement("script");
  clusterScript.src = "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js";
  clusterScript.defer = true;

  clusterScript.onload = () => {
    callback();
  };

  document.head.appendChild(clusterScript);
},


  displayGoogleMap() {
  // if (!this.map) {
  //   this.map = new window.google.maps.Map(document.getElementById("tour-map"), {
  //     center: { lat: 37.7749, lng: -122.4194 },
  //     zoom: 2,
  //   });
  // }

  if (!this.map) {
  this.map = new window.google.maps.Map(document.getElementById("tour-map"), {
    center: this.mapCenter,
    zoom: this.mapZoom
  });
}


  const addMarker = (lat, lng, title, color) => {
    return new google.maps.Marker({
      position: { lat, lng },
      title,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 6,
        fillColor: color,
        fillOpacity: 1,
        strokeWeight: 1,
        strokeColor: "#fff"
      }
    });
  };

  const allMarkers = [];

  const formatLabel = (concert, type) => {
    const venue = concert.venue || "Unknown Venue";
    const location = concert.location || "";
    return `${venue}, ${location} (${type})`;
  };

  // Existing Past (Blue), Future (Green), Predicted (Purple) markers
  [...this.pastConcerts, ...this.futureConcerts, ...this.futureTours].forEach(c => {
    const lat = c.lat || c.latitude;
    const lng = c.lng || c.longitude;
    const color =
      c.source === "Prediction" ? "#9C27B0" :
      c.source === "Ticketmaster" ? "#FF5722" :
      c.source === "Setlist.fm" ? "#03A9F4" :
      "#34A853"; // Default green
    const type = c.source || "Tour";

    if (lat && lng) {
      const marker = addMarker(lat, lng, formatLabel(c, type), color);
      allMarkers.push(marker);
    }
  });

  // Cluster markers
  if (window.MarkerClusterer) {
    new window.MarkerClusterer(this.map, allMarkers, {
      imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
    });
  }

  // Draw a route line through future concerts
  const routeCoords = this.futureConcerts
    .filter(e => e.lat && e.lng)
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .map(e => ({ lat: e.lat, lng: e.lng }));

  if (routeCoords.length >= 2) {
    const routeLine = new google.maps.Polyline({
      path: routeCoords,
      geodesic: true,
      strokeColor: "#FF6F00",
      strokeOpacity: 0.8,
      strokeWeight: 3,
    });
    routeLine.setMap(this.map);
  }

  // Fit all markers
  if (allMarkers.length > 0) {
    const bounds = new google.maps.LatLngBounds();
    allMarkers.forEach(marker => bounds.extend(marker.getPosition()));
    this.map.fitBounds(bounds);
  }
},

    updateChartData() {
      const regionCount = {};
      this.pastConcerts.forEach(c => {
        const country = c.location.split(',').pop().trim();
        regionCount[country] = (regionCount[country] || 0) + 1;
      });
      this.regionChartData.labels = Object.keys(regionCount);
      this.regionChartData.datasets[0].data = Object.values(regionCount);
    },

  // displayGoogleMap() {
  //     if (!this.map) {
  //       this.map = new window.google.maps.Map(document.getElementById("tour-map"), {
  //         center: { lat: 37.7749, lng: -122.4194 },
  //         zoom: 5,
  //       });
  //       this.directionsService = new window.google.maps.DirectionsService();
  //       this.directionsRenderer = new window.google.maps.DirectionsRenderer();
  //       this.directionsRenderer.setMap(this.map);
  //     }

  //     if (this.venues.length > 1) {
  //       const waypoints = this.venues.slice(1, -1).map(venue => ({ location: venue.location, stopover: true }));
  //       const request = {
  //         origin: this.venues[0].location,
  //         destination: this.venues[this.venues.length - 1].location,
  //         waypoints: waypoints,
  //         travelMode: "DRIVING"
  //       };
  //       this.directionsService.route(request, (result, status) => {
  //         if (status === "OK") {
  //           this.directionsRenderer.setDirections(result);
  //         }
  //       });
  //     }
  //   },

    generateRegionHeatmap() {
      const regionCount = {};
      this.pastConcerts.forEach(c => {
        const country = c.location.split(',').pop().trim();
        regionCount[country] = (regionCount[country] || 0) + 1;
      });
      this.regionChartData.labels = Object.keys(regionCount);
      this.regionChartData.datasets[0].data = Object.values(regionCount);
    },


    async getSpotifyToken() {
      try {
        const response = await axios.post(
          "https://accounts.spotify.com/api/token",
          new URLSearchParams({
            grant_type: "client_credentials",
            client_id: "1522ec4d96914840aef42817fe1b387b",
            client_secret: "673c7686457a438488401835249dca6b",
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        return response.data.access_token;
      } catch (error) {
        console.error("Error fetching Spotify access token:", error);
      }
    },
async getTicketmasterEvents() {
  try {
    const today = new Date();
    const fiveYearsAgo = new Date();
    const twoYearsAhead = new Date();

    fiveYearsAgo.setFullYear(today.getFullYear() - 5);
    twoYearsAhead.setFullYear(today.getFullYear() + 2);

    let page = 0;
    let totalPages = null;
    let totalRequests = 0;
    const allEvents = [];

    this.pastConcerts = [];
    this.futureConcerts = [];

    this.aiTourSummary = "Loading Ticketmaster events...";

    do {
      this.aiTourSummary = `Loading Ticketmaster events... Page ${page + 1} of ${totalPages ?? '?'}`;

      const response = await axios.get(
        `https://app.ticketmaster.com/discovery/v2/events.json`, {
          params: {
            keyword: this.artistData.name,
            size: 200,
            page,
            apikey: 'urzDHfIpUlR6bHW3gSuErLG9Vt3yEdKm'
          }
        }
      );

      totalRequests++;
      const pageEvents = response.data._embedded?.events || [];
      allEvents.push(...pageEvents);
      totalPages = response.data.page.totalPages;
      page++;
    } while (page < totalPages);

    this.aiTourSummary = `✔️ Loaded ${totalRequests} page(s) from Ticketmaster.`;

    // Group events by date
    const eventsByDate = {};

    for (const event of allEvents) {
      const eventDate = new Date(event.dates.start.localDate);
      if (eventDate < fiveYearsAgo || eventDate > twoYearsAhead) continue;

      const dateKey = event.dates.start.localDate;
      const venue = event._embedded?.venues?.[0];
      if (!venue) continue;

      const venueName = venue.name || "Unknown Venue";
      const city = venue.city?.name || "Unknown City";
      const country = venue.country?.name || "Unknown Country";
      const location = `${city}, ${country}`;
      const capacity = parseInt(venue.capacity || 0);
      const venueType = (venue.name || "").toLowerCase();

      const concertData = {
        id: event.id,
        name: event.name,
        date: dateKey,
        venue: venueName,
        location,
        lat: venue.location?.latitude ? parseFloat(venue.location.latitude) : null,
        lng: venue.location?.longitude ? parseFloat(venue.location.longitude) : null,
        capacity,
        venueType,
        source: "Ticketmaster"
      };

      // Append to group by date
      if (!eventsByDate[dateKey]) eventsByDate[dateKey] = [];
      eventsByDate[dateKey].push(concertData);
    }

    // Determine the most valid event per day
    const highPriorityVenues = ["arena", "stadium", "theatre", "amphitheater", "center"];
    const selectBestEvent = (events) => {
      return events
        .sort((a, b) => {
          // Prefer known large venue types
          const aIsBig = highPriorityVenues.some(v => a.venueType.includes(v));
          const bIsBig = highPriorityVenues.some(v => b.venueType.includes(v));
          if (aIsBig && !bIsBig) return -1;
          if (!aIsBig && bIsBig) return 1;

          // Then prefer by capacity if available
          if (b.capacity && a.capacity) return b.capacity - a.capacity;

          return 0; // fallback: keep first
        })[0];
    };

    Object.values(eventsByDate).forEach(events => {
  const selected = selectBestEvent(events);
  const concertDate = new Date(selected.date);
  if (concertDate < today) {
    this.pastConcerts.push(selected);
  } else {
    this.futureConcerts.push(selected);
  }
});

// ✅ Sort upcoming events by date
this.futureConcerts.sort((a, b) => new Date(a.date) - new Date(b.date));
  this.pastConcerts.sort((a, b) => new Date(b.date) - new Date(a.date));
  this.updateChartData();


  } catch (error) {
    console.error("Ticketmaster error:", error);
    this.aiTourSummary = "❌ Failed to load Ticketmaster events.";
  }
},
async analyzeTourData() {
  this.loadingAI = true;
  try {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const currentPeriod = `${yyyy}-${mm}`;

    const totalConcerts = this.pastConcerts.length + this.futureConcerts.length;
    const topCities = {};
    [...this.pastConcerts, ...this.futureConcerts].forEach(event => {
      const key = event.city || event.location;
      if (key) topCities[key] = (topCities[key] || 0) + 1;
    });

    const sortedCities = Object.entries(topCities)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5)
      .map(([city, count]) => `${city} (${count})`);

    const cityText = sortedCities.length ? `Top Cities: ${sortedCities.join(", ")}` : "";

    const prompt = `
You are a smart AI Tour Analyst.

Analyze the artist’s full concert history and generate a structured report.

➡️ REQUIRED:
- Predict realistic future concerts for the next 6–12 months starting from ${currentPeriod}.
- Suggest date, city, and country for each.
- Use patterns you see in past & current future concerts.

Format:
{
  "predictions": [
    { "id": "1", "date": "YYYY-MM", "city": "City", "country": "Country" }
  ],
  "summary": "Summary of trends",
  "patternReport": "Seasonality, hotspots, gaps",
  "overallAnalysis": "Macro touring insights",
  "clientAcquisitionReport": "New regions to target",
  "extraConcerts": [
    { "id": "virtual-1", "date": "YYYY-MM-DD", "venue": "Venue Name", "location": "City, Country", "type": "past|future" }
  ]
}

Context:
Artist Name: ${this.artistData.name}
Genres: ${this.artistData.genres?.join(', ')}
Popularity: ${this.artistData.popularity}
${cityText}

Past Concerts: ${this.pastConcerts.length}
Future Concerts: ${this.futureConcerts.length}
Total: ${totalConcerts}
`;

    const response = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-4o",
        messages: [
          { role: "system", content: "You are an AI tour analyst." },
          { role: "user", content: prompt }
        ],
        max_tokens: 8000,
        temperature: 0.2
      },
      {
        headers: {
          Authorization: `Bearer YOUR_OPENAI_KEY`,
          "Content-Type": "application/json"
        }
      }
    );

    const content = response.data.choices[0].message.content;
    const match = content.match(/\{[\s\S]*?\}/);
    let parsed = null;
    if (match) {
      try {
        parsed = JSON.parse(match[0]);
      } catch (err) {
        console.warn("JSON parse failed", err);
      }
    }

    if (parsed) {
      this.futureTours = [];
      const summarySections = [];

      summarySections.push(`🧠 **Summary**\n${parsed.summary || "N/A"}`);
      summarySections.push(`📊 **Tour Pattern**\n${parsed.patternReport || "N/A"}`);
      summarySections.push(`🧭 **Overall Analysis**\n${parsed.overallAnalysis || "N/A"}`);
      summarySections.push(`🎯 **Client Strategy**\n${parsed.clientAcquisitionReport || "N/A"}`);

      if (parsed.predictions?.length) {
        summarySections.push("🔮 **Predicted Future Tours:**");
        for (const tour of parsed.predictions) {
          this.futureTours.push({
            ...tour,
            venue: `${tour.city} (Predicted)`,
            location: `${tour.city}, ${tour.country}`,
            source: "Prediction"
          });
          summarySections.push(`• ${tour.date} — ${tour.city}, ${tour.country}`);
        }
      }

      if (parsed.extraConcerts?.length) {
        summarySections.push("🧪 **AI-Identified Extra Concerts:**");
        parsed.extraConcerts.forEach(ec => {
          const [city, country] = ec.location.split(',').map(s => s.trim());
          const concert = {
            id: ec.id,
            date: ec.date,
            venue: ec.venue,
            location: ec.location,
            city,
            country,
            source: "AI-Enhanced"
          };
          if (ec.type === "past") this.pastConcerts.push(concert);
          else this.futureConcerts.push(concert);

          summarySections.push(`• ${ec.date} — ${ec.venue}, ${ec.location} (${ec.type})`);
        });
      }

      this.aiTourSummary = summarySections.join("\n\n");
    } else {
      this.aiTourSummary = content;
    }

  } catch (error) {
    console.error("AI analysis error:", error);
    this.aiTourSummary = "⚠️ AI analysis failed.";
  } finally {
    this.updatePredictedChartData();
    this.displayGoogleMap();
    this.loadingAI = false;
  }
}
,

openGoogleSearch() {
  const query = `${this.artistData?.name || this.artistQuery} tour dates site:ticketmaster.com OR site:setlist.fm OR site:bandsintown.com`;
  const url = `https://www.google.com/search?q=${encodeURIComponent(query)}`;
  window.open(url, "_blank");
},
    async getBandsintownEvents() {
  try {
    const response = await axios.get(
      `https://rest.bandsintown.com/artists/${encodeURIComponent(this.artistData.name)}/events?app_id=yourAppID`
    );
    const events = response.data || [];

    events.forEach(event => {
      const date = new Date(event.datetime);
      const concertData = {
        id: event.id || `${event.datetime}-${event.venue.name}`,
        date: event.datetime.split("T")[0],
        venue: event.venue.name,
        location: `${event.venue.city}, ${event.venue.country}`,
      };
      const today = new Date();

      if (date < today) {
        this.pastConcerts.push(concertData);
      } else {
        this.futureConcerts.push(concertData);
      }
    });
  } catch (error) {
    console.error("Error fetching Bandsintown events:", error);
  }
},


async getSetlistFmData() {
      try {
        const searchRes = await axios.get(`https://api.setlist.fm/rest/1.0/search/artists?artistName=${encodeURIComponent(this.artistData.name)}&p=1`, {
          headers: {
            'x-api-key': 'YOBeMYAiutbxYRjG2KX1bYmKx13uLCU2t72F',
            'Accept': 'application/json'
          }
        });

        const mbid = searchRes.data.artists?.[0]?.mbid;
        if (!mbid) return;

        const setlistRes = await axios.get(`https://api.setlist.fm/rest/1.0/artist/${mbid}/setlists?p=1`, {
          headers: {
            'x-api-key': 'YOBeMYAiutbxYRjG2KX1bYmKx13uLCU2t72F',
            'Accept': 'application/json'
          }
        });

        const today = new Date();
        const setlists = setlistRes.data.setlist || [];
        setlists.forEach(set => {
          const date = new Date(set.eventDate.split('-').reverse().join('-'));
          const concertData = {
            id: set.id,
            date: set.eventDate,
            venue: set.venue?.name || 'Unknown',
            location: `${set.venue?.city?.name || ''}, ${set.venue?.city?.country?.name || ''}`,
            lat: parseFloat(set.venue?.city?.coords?.lat),
            lng: parseFloat(set.venue?.city?.coords?.long),
            source: 'Setlist.fm'
          };

          if (date < today) {
            this.pastConcerts.push(concertData);
          } else {
            this.futureConcerts.push(concertData);
          }
        });
      } catch (error) {
        console.error('Setlist.fm error:', error);
      }
    },

editArtist(artist) {
  this.artistData = {
    id: artist.id,
    name: artist.name,
    images: [{ url: artist.image }],
    followers: { total: 0 },
    popularity: 0,
    genres: [],
  };

  this.pastConcerts = artist.pastConcerts || [];
  this.futureConcerts = artist.futureConcerts || [];
  this.futureTours = artist.predictions || [];

  this.aiTourSummary = artist.aiTourSummary || '';
  this.aiTourPattern = artist.aiTourPattern || '';
  this.aiTourAnalysis = artist.aiTourAnalysis || '';
  this.aiClientReport = artist.aiClientReport || '';

  this.mapCenter = artist.mapCenter || { lat: 37.7749, lng: -122.4194 };
  this.mapZoom = artist.mapZoom || 2;

  this.isEditing = true;
  this.editingArtistId = artist.id;

  this.updateChartData();
  this.updatePredictedChartData();
  this.displayGoogleMap();
  this.generateRegionHeatmap();
},
    deleteArtist() {
      this.artistGallery = this.artistGallery.filter(
        artist => artist.id !== this.artistData.id
      );
      this.artistData = null;
      this.pastConcerts = [];
      this.futureTours = [];
    },
  },
  computed: {
  setlistConcerts() {
    return this.pastConcerts.filter(c => c.source === "Setlist.fm");
  },
  paginatedPastConcerts() {
    return this.pastConcerts.slice(0, this.paginationLimit);
  }
},
mounted() {
  window.initMap = this.displayGoogleMap;
  this.loadGoogleMapsAPI();

  const savedState = this.artistData
    ? localStorage.getItem(`mapState_${this.artistData.id}`)
    : null;

  if (savedState) {
    const center = JSON.parse(savedState);
    if (this.map) this.map.setCenter(center);
  }
  this.loadGoogleMapsAPI();
  const savedGallery = localStorage.getItem("artistGallery");
  if (savedGallery) {
    this.artistGallery = JSON.parse(savedGallery);

    // Render mini maps for each artist
    this.$nextTick(() => {
      this.artistGallery.forEach((artist) => {
        if (!artist.mapCenter) return;
        const mapDiv = document.getElementById(`mini-map-${artist.id}`);
        if (!mapDiv) return;

        const map = new google.maps.Map(mapDiv, {
          center: artist.mapCenter,
          zoom: artist.mapZoom || 2,
          disableDefaultUI: true,
          gestureHandling: "none"
        });

        const allConcerts = [
          ...(artist.pastConcerts || []),
          ...(artist.futureConcerts || []),
          ...(artist.predictions || [])
        ];

        allConcerts.forEach(e => {
          if (e.lat && e.lng) {
            new google.maps.Marker({
              map,
              position: { lat: e.lat, lng: e.lng },
              title: `${e.venue || e.city}, ${e.location}`,
              icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 4,
                fillColor: "#00eaff",
                fillOpacity: 0.8,
                strokeWeight: 1,
                strokeColor: "#fff"
              }
            });
          }
        });
      });
    });
  }
},

};
</script>

<style>
.ai-report-title {
  font-size: 1.5rem;
  margin: 20px 0 10px;
  color: #ffffff;
  border-bottom: 1px solid #2e3a4b;
  padding-bottom: 6px;
}

.styled-report {
  background: #111827;
  padding: 20px;
  border-radius: 12px;
  font-size: 0.95rem;
  color: #d1d5db;
  font-family: 'Inter', sans-serif;
  line-height: 1.6;
  white-space: normal;
}

.styled-report .report-text strong {
  color: #00eaff;
}

.artist-mini-map {
  width: 100%;
  height: 180px;
  margin: 12px 0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: inset 0 0 6px rgba(0, 255, 255, 0.1);
}

.mini-section {
  margin-top: 10px;
  text-align: left;
  font-size: 0.8rem;
}

.mini-section h5 {
  color: #00eaff;
  font-weight: 600;
  margin: 8px 0 4px;
}

.mini-tour-list {
  list-style-type: none;
  padding-left: 0;
  margin: 0 0 10px 0;
  color: #ccc;
}

.mini-tour-list li {
  padding: 2px 0;
}
.mini-tour-list li span {
  color: #00eaff;
  font-weight: bold;
}
.ai-report {
  white-space: pre-wrap;
  font-family: 'Inter', sans-serif;
  line-height: 1.6;
}
.styled-report pre {
  background: #111827;
  padding: 15px;
  border-radius: 10px;
  white-space: pre-wrap;
  color: #cceeff;
  font-family: "JetBrains Mono", monospace;
  font-size: 0.85rem;
  line-height: 1.6;
}
.styled-report {
  background: #0f1626;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 234, 255, 0.2);
}

.ticket-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 20px;
  padding: 10px;
}

.ticket-card {
  background: linear-gradient(145deg, rgba(30, 30, 50, 0.9), rgba(15, 15, 30, 0.9));
  border: 1px solid #0ff;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  color: #fff;
  box-shadow: 0 0 8px #0ff, 0 0 20px rgba(0, 255, 255, 0.2);
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  transition: transform 0.2s ease, box-shadow 0.3s ease;
}

.ticket-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 12px #00ffe1, 0 0 25px rgba(0, 255, 255, 0.4);
}

.ticket-date {
  font-size: 1.1rem;
  color: #00ffe1;
  font-weight: bold;
  margin-bottom: 8px;
}

.ticket-venue {
  font-size: 1rem;
  color: #ffffff;
  margin-bottom: 4px;
}

.ticket-location {
  font-size: 0.95rem;
  color: #aaa;
}

.ai-avatar2 {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  margin-right: 10px;
}
.artist-container {
  display: grid;
  grid-template-columns: 2fr;
  gap: 30px;
  padding: 80px 100px 100px 100px;
  background: #0c161bb6;
  color: #f5f5f5;
  min-height: 100vh;
  box-sizing: border-box;
  align-content: center;
  justify-content: center;
  text-align: center;
  font-family: 'Arial', sans-serif;
}

h3, h4 {
  color: #00eaff;
  margin-bottom: 10px;
}
.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #00eaff;
  margin-top: -300px;
}

.search-section {
  background: #1c2239;
  padding: 40px 10px 40px 10px;
  border: 1px solid #00eaff;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 234, 255, 0.2);
  text-align: center;
  margin-block: 0px;
}

.search-box {
  width: 100%;
  max-width: 400px;
  padding: 12px 15px ;
  font-size: 1.2rem;
  border-radius: 8px;
  border: none;
  outline: none;
  margin-bottom: 15px;
  background: #0f1626;
  color: #fff;
  border: 1px solid #00eaff;
}

.search-button {
  background-color: #00eaff;
  color: #0f1626;
  font-size: 1.1rem;
  font-weight: bold;
  padding: 25px 25px 25px 25px;
  border-radius: 8px;
  left: 20px;
}

.artist-profile {
  background: #1c2239;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 0 15px rgba(0, 255, 200, 0.15);
}

.artist-image, .gallery-image {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  margin: 10px auto;
  display: block;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.3);
}

ul {
  list-style: none;
  padding: 0;
  margin: 20px 0;
}

li {
  background: rgba(255, 255, 255, 0.04);
  padding: 12px 15px;
  border-radius: 10px;
  margin-bottom: 12px;
  text-align: left;
}

#tour-map {
  width: 100%;
  height: 500px;
  border-radius: 12px;
  border: 2px solid #00eaff;
  margin-top: 20px;
}

.ai-report {
  background: #0f1626;
  border: 1px solid #333;
  border-radius: 10px;
  padding: 20px 30px 20px 30px;
  margin-block: 20px;
  font-family: 'Courier New', monospace;
  font-size: 1.22rem;
  color: #ddd;
  white-space: pre-wrap;
  text-align: left;
  line-height: 1.5;
}

.v-divider {
  margin: 30px 0;
}

.v-btn {
  margin: 10px 5px;
}

.analyze-button,
.save-button,
.edit-button,
.delete-button {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: bold;
  background-color: #1c2239;
  border: 1px solid #00eaff;
  color: #00eaff;
  transition: all 0.3s ease;
}

.analyze-button:hover {
  background-color: #00eaff;
  color: #141e30;
}
.save-button:hover {
  background-color: #10ac84;
}
.edit-button:hover {
  background-color: #feca57;
  color: #000;
}
.delete-button:hover {
  background-color: #ee5253;
}

.section-title {
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: #ffffff;
  font-weight: 600;
  border-bottom: 1px solid #2e3a4b;
  padding-bottom: 10px;
}

.artist-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.artist-card {
  background-color: #121a26;
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
  color: #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.artist-card:hover {
  transform: translateY(-4px);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.gallery-image {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  border: 2px solid #00eaff33;
}

.artist-meta {
  flex: 1;
}

.artist-name {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.summary-text {
  font-size: 0.85rem;
  color: #94a3b8;
  margin-top: 4px;
}

.stats {
  display: flex;
  justify-content: space-between;
  background-color: #1a2536;
  padding: 10px;
  border-radius: 8px;
}

.stat-item {
  text-align: center;
}

.stat-label {
  display: block;
  font-size: 0.75rem;
  color: #8899a6;
}

.stat-value {
  font-size: 1rem;
  font-weight: bold;
  color: #00eaff;
}

.location-info {
  font-size: 0.85rem;
  color: #cbd5e1;
  border-top: 1px dashed #2d3748;
  padding-top: 8px;
}

.mini-lists {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 0.75rem;
}

.mini-block {
  flex: 1;
}

.mini-block h4 {
  margin-bottom: 4px;
  font-weight: 600;
  font-size: 0.8rem;
  color: #00eaff;
}

.mini-block ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mini-block li {
  margin-bottom: 4px;
  color: #c3d1e1;
}

.artist-card-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

.edit-button,
.delete-button {
  font-size: 0.75rem;
  padding: 6px 10px;
  min-width: unset;
}
.artist-card-buttons .edit-button {
  background-color: #feca57;
  color: #000;
}

.tour-info {
  font-size: 0.85rem;
  margin-top: 12px;
  text-align: left;
  color: #bbb;
}

.tour-info p {
  margin: 4px 0;
  word-break: break-word;
}

.ai-summary {
  display: block;
  font-style: italic;
  color: #7ae2f8;
}

.artist-card-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
}

.gallery-image {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid #00eaff55;
}

@media screen and (max-width: 768px) {
  .artist-cards {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 768px) {
  .artist-container {
    padding: 20px 15px;
  }

  .search-box {
    width: 100%;
    font-size: 0.95rem;
  }

  .artist-image, .gallery-image {
    width: 100px;
    height: 100px;
  }

  .analyze-button,
  .save-button,
  .edit-button,
  .delete-button {
    padding: 8px 16px;
    font-size: 0.9rem;
  }

  .ai-report {
    font-size: 0.9rem;
  }
}

</style>
